import type { IAction } from '../../action/IAction'
import { Product } from '../Product'
import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class GetComputedQuantityOnHandArgs extends ActionArgs {
  @Field(() => String)
  productId: string

  @Field(() => Boolean)
  requiredOnly?: boolean

  @Field(() => [Product])
  products?: Product[]
}

export interface IGetProductComputedQuantityOnHand extends IAction<number, GetComputedQuantityOnHandArgs> {}
